module.exports = __webpack_public_path__ + "img/Login-Sign-Up-Illustration.0b7e9822.svg";